/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const FileFields = gql`
  fragment FileFields on FileFieldType {
    name
    url
  }
`;
